import { Link } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import { LogOut, User } from 'lucide-react'

const Header: React.FC = () => {
  const { user, logout } = useAuthContext()

  return (
    <header className="shadow-lg border-b" style={{background: 'rgba(15, 23, 42, 0.95)', backdropFilter: 'blur(20px)', borderColor: 'rgba(58, 158, 90, 0.3)'}}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
                <Link to="/" className="flex items-center space-x-3">
                  <img
                    src="/assets/ifdlogo.png"
                    alt="Inland Fiber AI Logo"
                    className="h-8 w-8"
                  />
                  <span className="text-2xl font-bold" style={{color: '#3A9E5A'}}>
                    Inland Fiber AI
                  </span>
                </Link>
          </div>
          
          <nav className="flex items-center space-x-4">
            {user ? (
              <>
                <Link
                  to="/dashboard"
                  className="flex items-center space-x-2 hover:opacity-80 transition-all duration-200"
                  style={{color: '#e5e7eb'}}
                >
                  <User className="h-5 w-5" />
                  <span>Dashboard</span>
                </Link>
                <button
                  onClick={logout}
                  className="flex items-center space-x-2 hover:opacity-80 transition-all duration-200"
                  style={{color: '#e5e7eb'}}
                >
                  <LogOut className="h-5 w-5" />
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/pricing"
                  className="hover:opacity-80 transition-all duration-200 font-medium"
                  style={{color: '#e5e7eb'}}
                >
                  Pricing
                </Link>
                <Link
                  to="/login"
                  className="hover:opacity-80 transition-all duration-200 font-medium"
                  style={{color: '#e5e7eb'}}
                >
                  Login
                </Link>
                <Link
                  to="/register"
                  className="btn btn-primary"
                >
                  Get Started
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
